module.exports = __webpack_public_path__ + "assets/img/13.e3050e3f.jpg";